export const PACKAGE_NAME = 'jiraIssueTableHideDoneToggle';
export const TEAM_NAME = 'keystone';

export const HIDE_DONE_EXPERIENCE = 'hideDoneToggle';
export const ANALYTICS_SOURCE = 'jira-native-issue-table' as const;
